document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('[data-accordion-item]');

  accordionItems.forEach((details) => {
    const updateAccordion = () => {
      details.classList.toggle('is-open', !!details.open);
    };

    updateAccordion();

    details.addEventListener('toggle', updateAccordion);
  });
});